import { render, staticRenderFns } from "./BankIcon.vue?vue&type=template&id=84f440c0&"
import script from "./BankIcon.vue?vue&type=script&lang=js&"
export * from "./BankIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports